import {computed} from '@api'
import {CatalogStore} from '@stores'

export class CatalogFooterStore {
  constructor(public catalog: CatalogStore) {
  }

  @computed get visible() {
    const {settings: {imageSource, toolbarItems}} = this.catalog

    return (toolbarItems?.sliders?.location === 'footer' && toolbarItems?.sliders?.visible) || (imageSource?.toolbar?.location === 'footer')
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogFooterStore.ts